<template>
    <div class="col-sm-9 col-sm-offset-3 col-md-10 col-md-offset-2 main">
        <div class="row">
            <h1 class="page-header">
                Campaigns Usb Ducky
            </h1>
        </div>
        <div id="flashes" class="row"></div>
        <div class="row">
            <div :style="[ this.user.role == 'Reader' && this.user.usb==true ? { display: 'none' } : null ]">
                <button type="button" class="btn btn-primary" data-toggle="modal" data-backdrop="static" data-target="#modal" onclick="edit('new')">
                    <i class="fa fa-plus"></i> New Campaign Usb Ducky</button>
            </div>
        </div>
        &nbsp;
    
        <ul class="nav nav-tabs" role="tablist">
            <li class="active" role="activeCampaigns"><a href="#activeCampaigns" aria-controls="activeCampaigns" role="tab"
                    data-toggle="tab">Active Campaigns</a></li>
            <li role="archivedCampaigns"><a href="#archivedCampaigns" aria-controls="archivedCampaigns" role="tab"
                    data-toggle="tab">Archived Campaigns</a></li>
        </ul>
        <!-- </br> -->
        <div class="tab-content">
            <div role="tabpanel" class="tab-pane active" id="activeCampaigns">
                <div id="flashes" class="row"></div>
                &nbsp;
                <div id="loading">
                    <i class="fa fa-spinner fa-spin fa-4x"></i>
                </div>
                <div id="emptyMessage" class="row" style="display:none;">
                    <div class="alert alert-info">
                        No campaigns created yet. Let's create one!
                    </div>
                </div>
                <div class="row">
                    <table id="campaignTable" class="table" style="display:none;">
                        <thead>
                            <tr>
                                <th class="col-md-3">Name</th>
                                <th class="col-md-4">Created Date</th>
                                <th class="col-md-2">Status</th>
                                <th class="col-md-3 no-sort"></th>
                            </tr>
                        </thead>
                        <tbody>
                        </tbody>
                    </table>
                </div>
            </div>
            <div role="tabpanel" class="tab-pane" id="archivedCampaigns">
                <!-- </br> -->
                <div id="emptyMessage" class="row" style="display:none;">
                    <!-- </br> -->
                    <div class="alert alert-info">
                        No archived campaigns.
                    </div>
                </div>
                <div class="row">
                    <table id="campaignTableArchive" class="table" style="display:none;">
                        <thead>
                            <tr>
                                <th class="col-md-3">Name</th>
                                <th class="col-md-4">Created Date</th>
                                <th class="col-md-2">Status</th>
                                <th class="col-md-3 no-sort"></th>
                            </tr>
                        </thead>
                        <tbody>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
    <!-- Modal -->
    <div class="modal fade" id="modal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close" onclick="dismiss()">
                        <span aria-hidden="true">&times;</span>
                    </button>
                    <h4 class="modal-title" id="campaignModalLabel">New Campaign Usb Ducky</h4>
                </div>
                <div class="modal-body" id="modal_body">
                    <div class="row" id="modal.flashes"></div>
                    <div class="form-group">
                        <label for="name">Name:</label>
                        <div class="form-group">
                            <input type="text" class="form-control" id="name" placeholder="Campaign name" autofocus>
                        </div>
                        <label for="name">Numero Usb Keys:</label>
                        <div class="form-group">
                            <input type="text" class="form-control" id="usb_keys_number" placeholder="Numero chiavi Usb" autofocus>
                        </div>
                             <DIV class="row">
                                
                                <div class="col-md-6">
                                    <label class="control-label" for="url">Launch Date </label>
                                    <input type="text" class="form-control" id="launch_date"  autocomplete="random-data"/>
                                </div>
                            </DIV>
                                <!--
                                <div class="col-md-6">
                                    <label class="control-label" for="delay">Send Emails By (Optional)
                                        <i class="fa fa-question-circle" data-toggle="tooltip" data-placement="right" title="If specified, Gophish will send emails evenly between the campaign launch and this date."></i>
                                    </label>
                                    <input type="text" class="form-control" id="send_by_date" autocomplete="random-data"/>
                                </div>
                                 -->
                           </div>
                            <!--  da continuare -->
                            <div class="row">
                                <label class="control-label" for="customers"><span>*</span>Related customer:</label>
                                <div class="form-group" id="customer-select">
                                    <select class="form-control selectbox" placeholder="" name="customers" id="customers" required >
                                        <option selected disabled value=""></option>
                                    </select>
                                </div>
                          </div>
                       <!--</div>
                        
                        
                        <label class="control-label" for="profile">Sending Profile:</label>
                        <div class="input-group" id="template-select">
                            <select class="form-control selectbox" placeholder="Sending Profile" name="profile"  id="profile" />
                            <option selected disabled value=""></option>
                            <span class="input-group-btn">
                                <button type="button" data-toggle="modal" data-backdrop="static" data-target="#sendTestEmailModal"
                                    class="btn btn-primary button">
                                    <i class="fa fa-envelope"></i> Send Test Email</button>
                            </span>
                        </div>
                        <label class="control-label" for="users">Groups:</label>
                        <div class="form-group" id="users-select">
                            <select class="form-control selectbox" multiple name="users" id="users" required>
                                <option></option>
                            </select>
                        </div> 
                       
                    </div>
                     -->  
                <!--</div>-->
            </div>
               
                <div class="modal-footer">
                    <button type="button" class="btn btn-default" data-dismiss="modal" onclick="dismiss()">Close</button>
                    <button type="button" id="launchButton" class="btn btn-primary" onclick="launch()">
                        <i class="fa fa-rocket"></i> Launch Campaign</button>
                </div>
            </div>
        </div>
    </div>
    <!---->
    <!-- Send Test Email Modal -->
    
    <div class="modal" id="sendTestEmailModal" tabindex="-1" role="dialog" aria-labelledby="modalLabel">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
             <!-- New Email Modal -->
              
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                    <h4 class="modal-title" id="sendTestEmailModalTitle">Send Test Email</h4>
                </div>
                <div class="modal-body">
                    <div class="row" id="sendTestEmailModal.flashes"></div>
                    <div class="row">
                        <div class="col-sm-12">
                            <label class="control-label" for="to">Send Test Email to:</label>
                        </div>
                        <br>
                        <div class="col-sm-2">
                            <input type="text" class="form-control" placeholder="First Name" name="to_first_name">
                        </div>
                        <div class="col-sm-2">
                            <input type="text" class="form-control" placeholder="Last Name" name="to_last_name">
                        </div>
                        <div class="col-sm-4">
                            <input type="email" class="form-control" placeholder="Email" name="to_email" required>
                        </div>
                        <div class="col-sm-4">
                            <input type="text" class="form-control" placeholder="Position" name="to_position">
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" data-dismiss="modal" class="btn btn-default">Cancel</button>
                    <button type="button" class="btn btn-primary" id="sendTestModalSubmit" onclick="sendTestEmail()">
                        <i class="fa fa-envelope"></i> Send</button>
                </div>
            </div>
        </div>
    </div>

</template>
  
<script>
export default {
    name: 'CampaignsComponentUsb',
    //props: {
    //  msg: String
    //}
    mounted() {

        let customScript = document.createElement('script')

        customScript.setAttribute('src', '/scripts/campaignsUsb.js')

        customScript.setAttribute('type', 'application/javascript')

        document.head.appendChild(customScript)

        let customScript2 = document.createElement('script')

        customScript2.setAttribute('src', '/scripts/utils.js')

        customScript2.setAttribute('type', 'application/javascript')

        document.head.appendChild(customScript2)
    },
    methods: {
        getUserFromSession() {
            this.utente = window.sessionStorage.getItem('user');
        }
    },
    beforeMount() {
        this.user = window.sessionStorage.getItem("user");
        this.user = JSON.parse(this.user);
        if (null != this.user) {
            this.username = this.user.username;
        }
        this.getUserFromSession()

        //this.customers_load ()


    },
}
</script>

<style>

</style>